// src/components/Layout.js
import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";

function Layout({ userName, userRole, setUserName, setUserRole }) {
  const location = useLocation();
  const navigate = useNavigate();

  const hideHeaderRoutes = ["/login", "/register", "/forgot-password", "/"];
  const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);

  const [availableRoles, setAvailableRoles] = useState([]);

  useEffect(() => {
    const storedRoles = JSON.parse(localStorage.getItem("roles")) || [];
    setAvailableRoles(storedRoles);

    // Priority:
    // 1. activeRole
    // 2. first stored role
    const activeRole = localStorage.getItem("activeRole");

    if (activeRole) {
      setUserRole(activeRole);
    } else if (storedRoles.length > 0) {
      setUserRole(storedRoles[0]);
      localStorage.setItem("activeRole", storedRoles[0]);
    }
  }, [setUserRole]);

  const handleRoleChange = (e) => {
    const selected = e.target.value;

    // Update state + localStorage
    localStorage.setItem("activeRole", selected);
    setUserRole(selected);

    // Navigate to selected role dashboard
    switch (selected) {
      case "Admin":
        navigate("/dashboard/admin");
        break;

      case "Instructor":
        navigate("/dashboard/instructor");
        break;

      case "Student":
        navigate("/dashboard/student");
        break;

      default:
        navigate("/dashboard");
    }
  };

  // ---------------------------------------------------------
  // BACK BUTTON
  // ---------------------------------------------------------

  // Do not show Back button on dashboards
  const isDashboard =
    location.pathname === "/dashboard/admin" ||
    location.pathname === "/dashboard/instructor" ||
    location.pathname === "/dashboard/student";

  const showBackButton = !shouldHideHeader && !isDashboard;

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div>
      {!shouldHideHeader && (
        <>
          <Header
            userName={userName}
            userRole={userRole}
            setUserName={setUserName}
            setUserRole={setUserRole}
          />

          {/* -------------------------------------------------
              ROLE SWITCHER
             ------------------------------------------------- */}
          {availableRoles.length > 1 && (
            <div
              style={{
                textAlign: "right",
                marginRight: "20px",
                marginTop: "10px",
              }}
            >
              <label
                style={{
                  marginRight: "8px",
                  fontWeight: 500,
                }}
              >
                Switch Role:
              </label>

              <select
                value={userRole}
                onChange={handleRoleChange}
                style={{
                  padding: "5px 10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  backgroundColor: "#f9f9f9",
                  fontWeight: 500,
                }}
              >
                {availableRoles.map((role) => (
                  <option key={role} value={role}>
                    {role}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* -------------------------------------------------
              BACK BUTTON
             ------------------------------------------------- */}
          {showBackButton && (
            <div
              style={{
                maxWidth: "1230px",
                margin: "15px auto 5px auto",
                padding: "0 20px",
              }}
            >
              <button
                onClick={handleBack}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "7px 14px",
                  backgroundColor: "#f5f5f5",
                  color: "#333",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: 600,
                }}
              >
                ← Back
              </button>
            </div>
          )}
        </>
      )}

      <div style={{ padding: "5px" }}>
        <Outlet />
      </div>
    </div>
  );
}

export default Layout;